module.exports = __webpack_public_path__ + "static/media/logo.e630d0ce.png";